(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        var statLog = [];

        // Мост нативного приложения отдаёт данные сразу, но если он вдруг не ответит —
        // не блокируем инициализацию amplitude бесконечно.
        var WEBVIEW_BRIDGE_TIMEOUT_MS = 1500;

        var PIXEL_EVENT_LEAD = 'Lead';
        var PIXEL_EVENT_INITIATE_CHECKOUT = 'InitiateCheckout';
        var PIXEL_EVENT_VIEW_CONTENT = 'ViewContent';
        var PIXEL_EVENT_COMPLETE_REGISTRATION = 'CompleteRegistration';

        var isPixelInitialized = false;
        // храним отложенные события, пока не загрузились все скрипты
        window.pendingRoistatAnalyticEvents = [];
        window.pendingAmplitudeAnalyticEvents = [];

        /**
         * Почему-то gtm от brx uz не имеет этой функции, а она очень важна для гугл аналитики
         * dataLayer есть, а gtag нет
         */
        if (!window.gtag) {
            window.gtag = function () {
                if (typeof dataLayer !== 'undefined') {
                    dataLayer.push(arguments);
                }
            };
        }

        window.brxTracking = {
            visitNumber: null,
            amplitudeId: null,
            visitSaved: false,
            /**
             * Данные пользователя из нативного приложения — {deviceId, crmId},
             * любое из полей может быть null. Мост window.bridgeGetUserInfo есть только
             * внутри webview; в браузере и при сбое моста отдаём null, иначе
             * зависший мост навсегда заблокирует инициализацию amplitude.
             *
             * @returns {Promise<{deviceId: (string|null), crmId: (string|null)}|null>}
             */
            getWebViewUserInfo: function getWebViewUserInfo() {
                if (typeof window.bridgeGetUserInfo !== 'function') {
                    return Promise.resolve(null);
                }

                return Promise.race([Promise.resolve().then(function () {
                    return window.bridgeGetUserInfo();
                }), new Promise(function (resolve) {
                    return setTimeout(resolve, WEBVIEW_BRIDGE_TIMEOUT_MS, null);
                })])
                // Контракт моста не зафиксирован: нативная сторона может отдать
                // как объект, так и JSON-строку. Убрать, когда проверим на
                // приложении: window.bridgeGetUserInfo().then(r => console.log(typeof r))
                .then(function (raw) {
                    return typeof raw === 'string' ? JSON.parse(raw) : raw;
                }).catch(function (error) {
                    console.log('getWebViewUserInfo: ошибка моста', error);

                    return null;
                });
            },

            /**
             * Параметры инициализации amplitude: внутри приложения ведём аналитику
             * по deviceId/crmId приложения. Каждое поле подставляем отдельно — то,
             * что мост не заполнил, остаётся как пришло из PHP.
             *
             * @param {string|number|undefined} fallbackCrmId crmId из PHP
             * @param {object} params опции amplitude.init
             * @returns {Promise<{userId: (string|number|undefined), params: object}>}
             */
            getAmplitudeInitParams: function getAmplitudeInitParams(fallbackCrmId, params) {
                return window.brxTracking.getWebViewUserInfo().then(function (webViewUser) {
                    if (!webViewUser) {
                        return { userId: fallbackCrmId, params: params };
                    }

                    return {
                        userId: webViewUser.crmId || fallbackCrmId,
                        params: webViewUser.deviceId ? Object.assign({ deviceId: webViewUser.deviceId }, params) : params
                    };
                });
            },
            sendRoistatAnalyticsEvent: function sendRoistatAnalyticsEvent(eventName) {
                if (window.roistat) {
                    console.log('sendAnalyticsEvent: ' + eventName);
                    window.roistat.event.send(eventName);
                } else {
                    window.pendingRoistatAnalyticEvents.push(eventName);
                    console.log('sendAnalyticsEvent: roistat not exist, pending', eventName);
                }
            },
            sendAmplitudeAnalyticsEvent: function sendAmplitudeAnalyticsEvent(eventName) {
                var eventProperties = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

                eventProperties = Object.assign({}, window.htTravelFeedAnalytics ? window.htTravelFeedAnalytics.context() : {}, eventProperties);
                eventProperties = Object.assign({
                    'Site platform': window.app.isMobile ? 'Mobile' : 'Desktop',
                    'Platform type': window.app.platform,
                    'Is auth': !window.app.isGuest,
                    'AB test list': window.app.abTestList,
                    'Front id': window.app.frontId
                }, eventProperties);
                if ('pageParams' in window.app) {
                    eventProperties = Object.assign({}, window.app.pageParams, eventProperties);
                }
                if (window.app.isRussianClient === true) {
                    eventProperties['Is Russian client'] = true;
                }
                if (window.amplitude) {
                    console.log('sendAmplitudeAnalyticsEvent: ' + eventName, eventProperties);
                    window.amplitude.track(eventName, eventProperties);
                } else {
                    window.pendingAmplitudeAnalyticEvents.push({ eventName: eventName, eventProperties: eventProperties });
                    console.log('sendAnalyticsEvent: amplitude not exist, pending', eventName, eventProperties);
                }
            },

            sendAnalyticsEvent: function sendAnalyticsEvent(eventName) {
                var eventProperties = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

                if (app.availableAnalytic) {
                    window.brxTracking.sendAmplitudeAnalyticsEvent(eventName, eventProperties);
                    if (window.gtag) {
                        window.gtag('event', eventName, eventProperties);
                    }
                }
            },
            sendGoogleBookingEvent: function sendGoogleBookingEvent(tourPackageId, tourInfo, price, currency) {
                var _this = this;

                // отправка события покупки в GA4
                // https://netpeak.net/ru/blog/kak-nastroit-ot-slezhivaniye-elektronnoy-torgovli-v-ga4-cherez-kod-universal-analytics/
                var event = {
                    event: 'purchase',
                    ecommerce: {
                        transaction_id: tourPackageId,
                        affiliation: 'Site Online Store',
                        value: price,
                        currency: currency,
                        items: [{
                            item_name: tourInfo,
                            item_id: tourPackageId
                        }]
                    }
                };
                if (window.dataLayer) {
                    // Clear the previous ecommerce object.
                    window.dataLayer.push({ ecommerce: null });
                    window.dataLayer.push(event);
                    console.log('sendGoogleBookingEvent: ', event);
                } else {
                    console.log('sendGoogleBookingEvent: dataLayer not exist', event);
                    // пробуем раз в секунду, пока не загрузится gtm
                    setTimeout(function () {
                        _this.sendGoogleBookingEvent(tourPackageId, tourInfo, price, currency);
                    }, 1000);
                }
            },

            /**
             * @param {string} eventName
             */
            setEvent: function setEvent(eventName) {
                this.setYaEvent(eventName);
                if (eventName.indexOf('.') !== -1) {
                    var eventParams = eventName.split('.');
                    this.setGAEvent(eventParams[0], eventParams[1]);
                }
            },
            setGAEvent: function setGAEvent(eventCategory, eventAction) {
                var params = { eventCategory: eventCategory, eventAction: eventAction };
                console.log('setGAEvent:', params);
                if (isTrackingEnabled()) {
                    if (typeof window.dataLayer !== 'undefined') {
                        // На сайте установлен GTM
                        window.dataLayer.push({ event: eventCategory + "." + eventAction });
                    } else if (typeof window.ga !== 'undefined') {
                        window.ga('send', 'event', params);
                    }
                }
            },
            setYaEvent: function setYaEvent(name) {
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

                console.log('setYaEvent: ', name, params);
                if (typeof window.yaCounter16190941 !== 'undefined') {
                    window.yaCounter16190941.reachGoal(name, params);
                }
            },
            setRoistatVisitDeviceId: function setRoistatVisitDeviceId() {
                // сохраняем к себе
                window.brxTracking.saveRoistatVisit();
                window.brxTracking.saveAmplitudeId();

                // сохраняем в ройстат
                if (typeof window.amplitude !== 'undefined' && typeof window.amplitude.getDeviceId() !== 'undefined' && window.roistat) {
                    var params = {
                        roistat_param2: amplitude.getDeviceId(),
                        roistat_param3: window.brxUserActivity ? window.brxUserActivity.getVUid() : ''
                    };
                    // Нужен для отслеживания оффлайн конверсий ga4
                    var urlParams = new URLSearchParams(window.location.search);
                    var googleClickId = urlParams.get('gclid');
                    if (googleClickId) {
                        params.roistat_param4 = googleClickId;
                    }
                    window.roistat.setRoistatParams(params);
                }
            },

            saveRoistatVisit: function saveRoistatVisit() {
                if ('roistat' in window && window.roistat.visit) {
                    window.brxTracking.visitNumber = window.roistat.visit;
                    window.brxTracking.saveVisitParams();
                }
            },
            saveAmplitudeId: function saveAmplitudeId() {
                if (typeof window.amplitude !== 'undefined' && typeof window.amplitude.getDeviceId() !== 'undefined') {
                    window.brxTracking.amplitudeId = window.amplitude.getDeviceId();
                    window.brxTracking.saveVisitParams();
                }
            },
            saveVisitParams: function saveVisitParams() {
                if (!window.brxTracking.amplitudeId || !window.brxTracking.visitNumber || window.brxTracking.visitSaved) {
                    // console.log(
                    //     'saveVisitParams: skip',
                    //     window.brxTracking.amplitudeId,
                    //     window.brxTracking.visitNumber,
                    //     window.brxTracking.visitSaved
                    // );
                    return;
                }
                window.brxTracking.visitSaved = true;

                var vUid = window.brxUserActivity ? window.brxUserActivity.getVUid() : null;
                // Нужен для отслеживания оффлайн конверсий ga4
                var urlParams = new URLSearchParams(window.location.search);
                var googleClickId = urlParams.get('gclid');

                var params = {
                    visitNumber: window.brxTracking.visitNumber,
                    amplitudeId: window.brxTracking.amplitudeId,
                    vUid: vUid,
                    googleClickId: googleClickId
                };
                console.log('saveVisitParams send: ', params);
                ajax.post('/new/visit/save-visit-params', { params: params }, function () {
                    // console.log('saveVisitParams saved: ', params);
                });
            },
            /**
             * Отслеживание событий в pixel (facebook)
             * @see window.brxTracking.pixel
             * @param {string} event
             */
            setPixelEvent: function setPixelEvent(event) {
                if (typeof window.fbq === 'function') {
                    fbq('track', event);
                }
            },
            stat: function stat(type, params) {
                var isDisabled = app && app.debug === 1;
                var app = window.app;

                // если тут ставить window.top.location.href, то падает вебвизор из-за CORS
                var data = {
                    ukey: app.ukey,
                    cityId: app.city && app.city.id ? app.city.id : null,
                    realCityId: app.realCity && app.realCity.id ? app.realCity.id : null,
                    srcId: app.src_id,
                    type: type,
                    href: window.location.href,
                    isFrame: window != window.top,
                    params: params
                };

                if (isDisabled) {
                    console.log('stat localhost: ', data);
                    return;
                }

                var rt = window.rt;
                if (rt.isOnline()) {
                    rt.go('stat.save', data);
                } else {
                    statLog.push(data);
                    rt.afterLogin['saveStatLog'] = function () {
                        if (statLog.length) {
                            rt.go('stat.save', statLog);
                            statLog = [];
                        }
                        delete rt.afterLogin['saveStatLog'];
                    };
                }
            },
            statCurrency: function statCurrency(currency) {
                this.stat(14, { info: currency });
            },

            /**
             * @param {number} cityId
             */
            updateSourceVisit: function updateSourceVisit(cityId) {
                var srcId = null;
                var app = window.app;
                if (app.updateSourceId !== undefined) {
                    srcId = app.updateSourceId;
                } else if (!document.referrer) {
                    srcId = 33; // прямой вход
                }
                if (srcId !== null) {
                    $.get('/site/updateCounter', {
                        src_id: srcId,
                        city_id: cityId
                    });
                }
            },
            initFaceBookPixel: function initFaceBookPixel(cityId) {
                if (!isTrackingEnabled() || isPixelInitialized) {
                    return;
                }
                isPixelInitialized = true;

                var pixelId = null;
                switch (cityId) {
                    case 3:
                        // Алматы
                        pixelId = '856421511127540';
                        break;
                    case 1:
                        // Астана
                        pixelId = '212197272519320';
                        break;
                    case 4:
                        // Караганда
                        pixelId = '362775650890207';
                        break;
                    case 22:
                        // Шымкент
                        pixelId = '386868035110715';
                        break;
                }
                if (pixelId !== null) {
                    !function (f, b, e, v, n, t, s) {
                        if (f.fbq) return;n = f.fbq = function () {
                            n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
                        };if (!f._fbq) f._fbq = n;
                        n.push = n;n.loaded = !0;n.version = '2.0';n.queue = [];t = b.createElement(e);t.async = !0;
                        t.src = v;s = b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t, s);
                    }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
                    fbq('init', pixelId); // Insert your pixel ID here.
                    fbq('track', 'PageView');
                }
            },

            callTrackingRefresh: function callTrackingRefresh() {
                console.log('callTrackingRefresh');
                if (window.roistatCallTrackingRefresh) {
                    window.roistatCallTrackingRefresh();
                }
                if (typeof jivo_api !== 'undefined' && 'roistatGetCookie' in window) {
                    jivo_api.setCustomData([{
                        "content": "\u041D\u043E\u043C\u0435\u0440 \u0432\u0438\u0437\u0438\u0442\u0430: \u200D" + window.roistatGetCookie('roistat_visit') + "\u200D"
                    }]);
                    console.log("Номер визита: " + window.roistatGetCookie('roistat_visit'));
                }
                window.brxTracking.refreshWhatsAppLink();
                window.brxTracking.setRoistatVisitDeviceId();
            },
            processRoistatAnalyticEvents: function processRoistatAnalyticEvents() {
                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                    for (var _iterator = window.pendingRoistatAnalyticEvents[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var eventName = _step.value;

                        console.log('Send roistat pending event: ' + eventName);
                        window.brxTracking.sendRoistatAnalyticsEvent(eventName);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                        }
                    } finally {
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }

                window.pendingRoistatAnalyticEvents = [];
            },
            processAmplitudeAnalyticEvents: function processAmplitudeAnalyticEvents() {
                var _iteratorNormalCompletion2 = true;
                var _didIteratorError2 = false;
                var _iteratorError2 = undefined;

                try {
                    for (var _iterator2 = window.pendingAmplitudeAnalyticEvents[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                        var event = _step2.value;

                        console.log('Send amplitude pending event: ' + event.eventName);
                        window.brxTracking.sendAmplitudeAnalyticsEvent(event.eventName, event.eventProperties);
                    }
                } catch (err) {
                    _didIteratorError2 = true;
                    _iteratorError2 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion2 && _iterator2.return) {
                            _iterator2.return();
                        }
                    } finally {
                        if (_didIteratorError2) {
                            throw _iteratorError2;
                        }
                    }
                }

                window.pendingAmplitudeAnalyticEvents = [];
            },
            refreshWhatsAppLink: function refreshWhatsAppLink() {
                if ('roistatGetCookie' in window) {
                    var message = "\u041C\u043E\u0439 \u043D\u043E\u043C\u0435\u0440 \u0437\u0430\u044F\u0432\u043A\u0438: \u200D{roistat_visit}\u200D \n--------------\n\u0417\u0434\u0440\u0430\u0432\u0441\u0442\u0432\u0443\u0439\u0442\u0435! \u041F\u043E\u0434\u0431\u0435\u0440\u0438\u0442\u0435 \u043C\u043D\u0435 \u0442\u0443\u0440 \u0432 ";
                    var text = message.replace(/{roistat_visit}/g, window.roistatGetCookie('roistat_visit'));
                    text = encodeURI(text);
                    var linkElements = document.querySelectorAll('[href*="//wa.me/"]');
                    var _iteratorNormalCompletion3 = true;
                    var _didIteratorError3 = false;
                    var _iteratorError3 = undefined;

                    try {
                        for (var _iterator3 = linkElements[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                            var element = _step3.value;

                            if (element.getAttribute('data-roistat-update') == 0) {
                                continue;
                            }
                            var url = element.href;
                            var param = 'text';
                            var value = text;
                            var explodedUrl = url.split('?');
                            var baseUrl = explodedUrl[0] || '';
                            var query = '?' + (explodedUrl[1] || '');
                            var regex = new RegExp("([?;&])" + param + "[^&;]*[;&]?");
                            var queryWithoutParameter = query.replace(regex, "$1").replace(/&$/, '');
                            element.href = baseUrl + (queryWithoutParameter.length > 2 ? queryWithoutParameter + '&' : '?') + (value ? param + "=" + value : '');
                        }
                        // console.log(linkElements);
                    } catch (err) {
                        _didIteratorError3 = true;
                        _iteratorError3 = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion3 && _iterator3.return) {
                                _iterator3.return();
                            }
                        } finally {
                            if (_didIteratorError3) {
                                throw _iteratorError3;
                            }
                        }
                    }
                } else {
                    console.log('refreshWhatsAppLink FAILED: roistatGetCookie not exist');
                }
            },
            pixel: {
                LEAD: PIXEL_EVENT_LEAD,
                INITIATE_CHECKOUT: PIXEL_EVENT_INITIATE_CHECKOUT,
                VIEW_CONTENT: PIXEL_EVENT_VIEW_CONTENT,
                COMPLETE_REGISTRATION: PIXEL_EVENT_COMPLETE_REGISTRATION
            },
            updateSmartScript: function updateSmartScript() {
                if (typeof AF_SMART_SCRIPT_RESULT === 'undefined') {
                    return;
                }
                var smartScriptVar = AF_SMART_SCRIPT_RESULT;
                var sessionClickURL = sessionStorage.getItem('clickURL');
                if (!sessionClickURL && smartScriptVar !== undefined && smartScriptVar.clickURL !== undefined) {
                    sessionStorage.setItem('clickURL', smartScriptVar.clickURL);
                }
            }
        };

        if (window.htTravelFeedAnalytics && window.htTravelFeedAnalytics.flushPending) {
            window.htTravelFeedAnalytics.flushPending();
        }
    }, {}] }, {}, [1]);